import React, { useState } from 'react';
import { message } from 'antd';
import { SFuncModal } from 'shj-components';
import {callValid, submitValidByCall} from '@/services/callCenter'
export function submitValidModalFn({ fn, ...rest }) {
    const destroy = () => {
        dialog.destroy();
    };
    const dialog: any = SFuncModal({
        title: '提交有效',
        width: 400,
        vanish: true,
        content: <SubmitValidFnDom fn={fn} onClose={destroy} {...rest} />,
    });
}
const SubmitValidFnDom: React.FC<any> = ({ fn, onClose, clueId, content, ...rest }) => {

    const [loading, setLoading] = useState(false);

    const onFinish = () => {
        if (loading) return
        setLoading(true)
        callValid({clueId}).then(res => {
            message.success(res?.message || '操作成功')
            onClose()
            fn && fn()
        }).finally(() => {
            setLoading(false)
        })

    }
    return <SFuncModal.Content
        cancelText="取消"
        onCancel={onClose}
        onOk={onFinish}
        confirmLoading={loading}
    >
        {content}
    </SFuncModal.Content>
}